import type React from 'react';

import { StraightArrowRightIcon } from '@vlabs/icons';
import type { CircleAnimatedButtonProps } from '@vlabs/uikit';
import { CircleAnimatedButton } from '@vlabs/uikit';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import { Link } from 'react-router-dom';

import { useGoToCardTranslation } from './i18n';
import { generateLink } from './link';
import type { GoToCardProps } from './types';

interface GoToCardCircleAnimatedButtonProps extends GoToCardProps,
  Omit<CircleAnimatedButtonProps, 'children' | 'icon'>, Pick<ButtonProps, 'icon'> {}

function GoToCardCircleAnimatedButton({
  cardId,
  ...props
}: GoToCardCircleAnimatedButtonProps): React.JSX.Element {
  const { t } = useGoToCardTranslation();
  return (
    <CircleAnimatedButton
      as={Link}
      data-testid="goToCardPageButton"
      icon={<StraightArrowRightIcon />}
      to={generateLink(cardId)}
      {...props}
    >
      {t('title')}
    </CircleAnimatedButton>
  );
}

export { GoToCardCircleAnimatedButton };
